import * as $ from "jquery";
import * as _ from "lodash";
import {ModuleConfigView} from "./ModuleConfigView";

var moduleConfigTemplate = require('templates/settings/sensor_config/modulev5.html');

export class ModuleV5ConfigView extends ModuleConfigView {

    template = _.template(moduleConfigTemplate);

    constructor(options) {
        super(_.extend({
            events: {
                'change .settings-sensorconfig-module-node-mode': 'handleChangeModuleMode',
                'change .settings-sensorconfig-module-time-sync-select': 'handleChangeTimeSync',
                'change .settings-sensorconfig-module-stickyPanId-select': 'handleChangeInstallLock',
                'change .settings-sensorconfig-module-outdoors': 'handleChangeOutdoors'
            }
        }, options))
    }

    render() {
        var panId;

        if (this.config.findWhere({type: "NODE_STICKY_PAN_ID"}).get('value') === 1 || this.isGateway) {
            panId = this.config.findWhere({type: "PAN_ID"}).get('value');
        } else {
            panId = this.lastPanId;
        }
        panId = panId.toString(16).toUpperCase();

        const hasIAQSensors = this.module.get('sensors').some(sensor => sensor.sensor_type === 34);
        
        let moduleOutdoorsValue = false;
        if (hasIAQSensors) {
            const iaqSensor = this.module.get('sensors').find(sensor => sensor.sensor_type === 34);
            if (iaqSensor) {
                const isOutdoorsValue = iaqSensor.is_outdoors;
                moduleOutdoorsValue = isOutdoorsValue === true || Number(isOutdoorsValue) === 1 || String(isOutdoorsValue) === "1";
            }
        }

        this.$el.html(this.template({
            config: this.config,
            isGateway: this.isGateway,
            panId: panId,
            module: this.module,
            con: this.module.getConnector(0),
            moduleNumber: Number(this.module.get('module_number')),
            permissionCollection: this.permissionCollection,
            installId: this.installId,
            currentUser: this.currentUser,
            orgId: this.orgId,
            hasIAQSensors: hasIAQSensors,
            moduleOutdoorsValue: moduleOutdoorsValue
        }));

        // Activate tooltips
        (<any> this.$('[data-toggle="tooltip"]')).tooltip();

        return this;
    }

    handleChangeModuleMode(e: JQuery.UIEventBase) {
        var val = $(e.currentTarget).val();

        //If we select Node chooses, we need to know if hidden fields should show or not
        //based on whether the Node is actually on battery, or reports that it is acting as endpoint or endpoint relay
        if(val == 0){
            var show =  this.module.isBatteryPowered();
        }  else {
            show = (val == 2 || val == 4);
        }

        if(show){
            this.$('.settings-sensorconfig-internal-sensors-form-group').removeClass('hidden');
            this.$('.settings-sensorconfig-update-listen-frequency-form-group').removeClass('hidden');
        } else {
            this.$('.settings-sensorconfig-internal-sensors-form-group').addClass('hidden');
            this.$('.settings-sensorconfig-update-listen-frequency-form-group').addClass('hidden');
        }
    }

    handleChangeTimeSync(e: JQuery.UIEventBase){
        var val = $(e.currentTarget).val();

        if((val>= 0) && (val<= 59)){
            this.$('.settings-sensorconfig-module-time-sync-form-group').removeClass('hidden');
            this.$('.settings-sensorconfig-module-time-sync-size').removeClass('col-sm-9');
            this.$('.settings-sensorconfig-module-time-sync-size').addClass('col-sm-6');
        } else {
            this.$('.settings-sensorconfig-module-time-sync-form-group').addClass('hidden');
            this.$('.settings-sensorconfig-module-time-sync-size').removeClass('col-sm-6');
            this.$('.settings-sensorconfig-module-time-sync-size').addClass('col-sm-9');
        }
    }

    handleChangeInstallLock(e: JQuery.UIEventBase){
        var val = $(e.currentTarget).val();

        if(val > 0 && val < 3){
            this.$('.settings-sensorconfig-module-pan-id').prop('disabled', false);
        } else {
            this.$('.settings-sensorconfig-module-pan-id').prop('disabled', true);
        }
    }

    getConfig() {
        var sensorId = this.config.first().get('sensor_id');
        var nodeMode = Number(this.$('.settings-sensorconfig-module-node-mode').val());
        if(this.module.getConnector(0).sensor_version > 4) {
            var internalSensors = Number(this.$('.settings-sensorconfig-module-internal-sensor').val());
        }else{
            var internalSensors = this.$('.settings-sensorconfig-module-internal-sensor').is(':checked') ? 3 : 0;
        }
        var pollingFreq = (<string>this.$('.settings-sensorconfig-module-polling-freq').val());
        var panId = (<string>this.$('.settings-sensorconfig-module-pan-id').val());
        var installLock = Number(this.$('.settings-sensorconfig-module-installation-lock-select').val());
        var stickyPanId = Number(this.$('.settings-sensorconfig-module-stickyPanId-select').val());
        var globalPollingFreq = (<string>this.$('.settings-sensorconfig-module-global-polling-freq').val());
        var pingInterval = (<string>this.$('.settings-sensorconfig-module-ping-interval').val());
        var listenFrequency = (<string>this.$('.settings-sensorconfig-module-update-listen-frequency').val());  //Is Discovery Interval for Node ver 5
        var sdDisable = this.config.findWhere({type: 'GATEWAY_DISABLE_SD'});
        var packedData = this.$('.settings-sensorconfig-module-packed-data').is(':checked') ? 1 : 0;

        if (this.$('.settings-sensorconfig-module-time-sync-select').val() >= 60) {
            var timeSync = Number((this.$('.settings-sensorconfig-module-time-sync-select').val()));
        } else {
            var timeSync = Math.min(59, Number(this.$('.settings-sensorconfig-module-time-sync-input').val()));
        }


        // For nodes if stickyPanId is enabled, we should write 0 as pan id into the configuration
        // Otherwise write the panId
        if ((stickyPanId == 0 || stickyPanId == 3) && !this.isGateway) {
            panId = '0';
        }

        // Disable Internal Sensor if Mode is Forced Node or If Node decides Mode and it doesn't act battery powered
        if (nodeMode === 3 || (!this.module.isBatteryPowered() && nodeMode === 0)) {
            internalSensors = 0;
        }

        var v3 = [{
            sensor_id: sensorId,
            type: "NODE_MODE",
            value: nodeMode ? Number(nodeMode) : 0
        }, {
            sensor_id: sensorId,
            type: "CHARGE_ENABLE",
            value: 1
        }, {
            sensor_id: sensorId,
            type: "INTERNAL_SENSORS",
            value: internalSensors
        }, {
            sensor_id: sensorId,
            type: "POLLING_FREQ",
            value: pollingFreq ? Number(pollingFreq) : 0
        }, {
            sensor_id: sensorId,
            type: "PAN_ID",
            value: panId ? parseInt(panId, 16) : 0
        }, {
            sensor_id: sensorId,
            type: "GATEWAY_GLOBAL_POLLING_FREQ",
            value: globalPollingFreq ? Number(globalPollingFreq) : 0
        }, {
            sensor_id: sensorId,
            type: "NODE_STICKY_PAN_ID",
            value: stickyPanId ? Number(stickyPanId) : 0
        }, {
            sensor_id: sensorId,
            type: "GATEWAY_PING_INTERVAL",
            value: pingInterval ? Number(pingInterval) : 0
        }, {
            sensor_id: sensorId,
            type: "NODE_LISTEN_FREQ",
            value: listenFrequency ? Number(listenFrequency) : 0
        }];

        if (this.module.getConnector(0).sensor_version >= 4) {
            v3.push({
                sensor_id: sensorId,
                type: "GATEWAY_DISABLE_SD",
                value: sdDisable.get('value')
            });
        }

        if (this.module.getConnector(0).sensor_version > 4) {
            v3.push({
                sensor_id: sensorId,
                type: "NODE_PACKED_DATA",
                value: packedData
            }, {
                sensor_id: sensorId,
                type: "SYNCHRONIZED_TIMESTAMP",
                value: (timeSync || (timeSync === 0)) ? Number(timeSync) : 253  //TODO check to make sure it is between 0 and 59, or 253, 254, or 255, where does data validation occur?
            }, {
                sensor_id: sensorId,
                type: "GATEWAY_INSTALLATION_LOCK",
                value: installLock ? Number(installLock) : 0
            });
        }

        return v3;
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/views/settings/sensor_config/ModuleV5ConfigView.ts